import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../lifechronicles/LifeChroniclesHome.css';

import {
  faCarrot,
  faDumbbell,
  faHospitalUser,
  faPrescriptionBottleMedical,
  faDog,
  faRulerCombined,
  faSyringe,
  faLeaf,
  faHeartPulse,
} from "@fortawesome/free-solid-svg-icons";

export const categories = [
    { to: "/routine-diet-list", icon: faCarrot, label: "DietRoutine", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/exercise-list", icon: faDumbbell, label: "Exercise", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/gym-list", icon: faDumbbell, label: "Gym", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/illness-list", icon: faHospitalUser, label: "Illness", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/medicine-list", icon: faPrescriptionBottleMedical, label: "Medicine", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/meditation-list", icon: faLeaf, label: "Meditations", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/pet-list", icon: faDog, label: "Pet", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/physicalgrowth-list", icon: faRulerCombined, label: "Physical Growth", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/vaccination-list", icon: faSyringe, label: "Vaccinations", bgColor: "bg-teal-600", textColor: "text-white" },
    { to: "/yoga-list", icon: faHeartPulse, label: "Yoga", bgColor: "bg-teal-600", textColor: "text-white" },
];


const SheEarnsHealthHome = () => {
    const navigate = useNavigate();

    return (
        <div className='flex flex-col min-h-screen'>
            <div className="flex flex-col min-h-[85vh] lg:min-h-[92vh] items-center mt-1 py-2 px-4 bg-black border border-pink-400 h-auto rounded-lg">
                <p className="text-lg lg:text-xl mb-1 text-yellow-200">SAKSHAM Shakti - Health & Wellness</p>
                <div className='flex flex-col flex-wrap justify-center gap-4 mt-2 text-sm'>
                    <div className="grid grid-cols-3 lg:grid-cols-5 gap-2">
                        {categories.map((category, index) => (
                            <Link 
                                key={index} 
                                to={category.to} 
                                className={`flex flex-col items-center p-2 lg:p-4 rounded-lg ${category.bgColor} ${category.textColor} shadow-lg hover:shadow-2xl transition-shadow duration-300`}
                            >
                                <FontAwesomeIcon icon={category.icon} size="x" className="mb-2" />
                                <span className="text-m flex items-center justify-center text-center">{category.label}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
            <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-xs lg:text-sm">
                    © 2025 Think5Whys Global DeepTech Solutions.
                    </div>
                    <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                        <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                        <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                        <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                        <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default SheEarnsHealthHome;
